<ng-container [formGroup]="parentForm">
  @if (format) {
    <input [id]="fcName" [type]="type" class="form-control" [formControlName]="fcName" [required]="required" [pattern]="pattern"
      [attr.maxlength]="maxlength || null" [attr.readonly]="readonly ? '' : null"
      (input)="onValueInput($event)" [attr.data-cy]="'text-'+fcName"
      [ngClass]="{ 'is-invalid': parentForm.controls[fcName].errors?.pattern }"
      appFormatCustomfield
      [formatCustom]="format"/>
  } @else {
    <input [id]="fcName" [type]="type" class="form-control" [formControlName]="fcName" [required]="required" [pattern]="pattern"
      [attr.maxlength]="effectiveMaxlength" [attr.readonly]="readonly ? '' : null" [attr.inputmode]="digitsOnly || mobilePePrefix ? 'numeric' : null"
      (input)="onValueInput($event)" [attr.data-cy]="'text-'+fcName"
      [ngClass]="{ 'is-invalid': parentForm.controls[fcName].errors?.pattern || parentForm.controls[fcName].errors?.email || parentForm.controls[fcName].errors?.validEmail}"
      />
  }
  @if (parentForm.controls[fcName].errors?.pattern || parentForm.controls[fcName].errors?.email || parentForm.controls[fcName].errors?.validEmail) {
    <small class="form-text text-muted danger" class="invalid-feedback">
      <div class="error-message ">
        {{ validationMessage }}
      </div>
    </small>
  }
</ng-container>